import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c7d5b07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-tile-internal" }
const _hoisted_2 = { class: "link-tile-internal-content" }
const _hoisted_3 = { class: "link-tile-internal-icon" }
const _hoisted_4 = { class: "link-tile-internal-label" }

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { scrollToTop } from '@/helpers/helpers';
import { LinkDataInternal } from '@/models/data';

export default /*#__PURE__*/_defineComponent({
  __name: 'LinkTileInternal',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: LinkDataInternal
}



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    class: "link-tile-internal-wrapper",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollToTop)())),
    to: `/${__props.data.page}`,
    title: __props.data.text
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: __props.data.icon
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.data.text.toLowerCase()), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "title"]))
}
}

})